import usePageTitle from "../utils/usePageTitle";
import { Container } from "common-tailwind-components";
import { FileJson, MessageSquare, Users, UsersRound } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useLogin } from "../reducers";
import { isAdmin } from "../utils/permissions";

const ExecutiveDashboard = () => {
  const { t } = useTranslation();
  const { permissions } = useLogin();
  usePageTitle(t("executive_dashboard"));

  return (
    <Container>
      <div className="mx-auto flex max-w-5xl flex-col gap-6 px-4 pb-8 pt-7">
        {/* No heading: the toolbar names the section and stays put. */}
        <p className="text-sm text-text-dim">{t("executive_dashboard_description")}</p>

        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          <Link
            to="/administration/user-management/"
            className="group rounded-2xl border border-outline bg-surface p-5 shadow-sm transition hover:border-primary/40 hover:bg-muted-surface"
          >
            <div className="space-y-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-primary/20 bg-primary/10 text-primary">
                <Users className="h-5 w-5" aria-hidden="true" />
              </div>
              <div>
                <div className="text-lg font-semibold text-text group-hover:text-primary">
                  {t("user_management")}
                </div>
                <p className="mt-2 text-sm text-text-dim">{t("manage_users_description")}</p>
              </div>
            </div>
          </Link>
          {isAdmin(permissions) && (
            <Link
              to="/administration/prompts/"
              className="group rounded-2xl border border-outline bg-surface p-5 shadow-sm transition hover:border-primary/40 hover:bg-muted-surface"
            >
              <div className="space-y-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-primary/20 bg-primary/10 text-primary">
                  <MessageSquare className="h-5 w-5" aria-hidden="true" />
                </div>
                <div>
                  <div className="text-lg font-semibold text-text group-hover:text-primary">
                    {t("prompt_config_title")}
                  </div>
                  <p className="mt-2 text-sm text-text-dim">
                    {t("prompt_config_card_description")}
                  </p>
                </div>
              </div>
            </Link>
          )}
          {isAdmin(permissions) && (
            <Link
              to="/administration/recording-import/"
              className="group rounded-2xl border border-outline bg-surface p-5 shadow-sm transition hover:border-primary/40 hover:bg-muted-surface"
            >
              <div className="space-y-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-info/20 bg-info/10 text-info">
                  <FileJson className="h-5 w-5" aria-hidden="true" />
                </div>
                <div>
                  <div className="text-lg font-semibold text-text group-hover:text-primary">
                    {t("recording_import")}
                  </div>
                  <p className="mt-2 text-sm text-text-dim">
                    {t("recording_import_card_description")}
                  </p>
                </div>
              </div>
            </Link>
          )}
          {isAdmin(permissions) && (
            <Link
              to="/administration/demo-users/"
              className="group rounded-2xl border border-outline bg-surface p-5 shadow-sm transition hover:border-primary/40 hover:bg-muted-surface"
            >
              <div className="space-y-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl border border-info/20 bg-info/10 text-info">
                  <UsersRound className="h-5 w-5" aria-hidden="true" />
                </div>
                <div>
                  <div className="text-lg font-semibold text-text group-hover:text-primary">
                    {t("tour.demo_user_import")}
                  </div>
                  <p className="mt-2 text-sm text-text-dim">
                    {t("tour.demo_user_import_card_description")}
                  </p>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ExecutiveDashboard;
